import Script from "next/script"
import { createElement, memo, useEffect, useState } from "react"

export const TrustedShopScript = memo(function TrustedShop() {
    const [mounted, isMounted] = useState(false)
    useEffect(() => {
        const handleScroll = () => {
            isMounted(true)
            window.removeEventListener("scroll", handleScroll)
        }
        window.addEventListener("scroll", handleScroll)
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])
    if (mounted && typeof window !== "undefined") {
        return <Script defer async id="trustedShop" src="https://integrations.etrusted.com/applications/widget.js/v2" />
    }
    return <></>
})

export const TrustedShopWidget = memo(function Widget({ className }: { className?: string }) {
    const widgetId = process.env.NEXT_PUBLIC_ETRUSTED_WIDGET
    if (!widgetId) return <></>
    return (
        <div className={className}>
            <div className="pointer-events-none scale-75 text-sm lg:pointer-events-auto lg:-m-3.75 lg:scale-100 lg:text-xs">
                {createElement("etrusted-widget", { id: "trustedShop", "data-etrusted-widget-id": widgetId })}
                <TrustedShopScript />
            </div>
        </div>
    )
})
